<template>
  <div>
    <vs-tabs alignment="fixed">
      <vs-tab :label="'Functionnality'">
        <div>
          <h4 class="mb-4">Setting</h4>
          <vs-input
            :danger="errors.name"
            :danger-text="
              $t('Errors.InvalidPolite', {
                field: $t('Kiosk.AddKioskPrompt.Name'),
              })
            "
            :label="$t('Kiosk.AddKioskPrompt.Name')"
            v-model="editPromptData.name"
            class="w-100 mb-2"
          />
          <vs-select
            :danger="errors.queues"
            :danger-text="
              $t('Errors.InvalidPolite', {
                field: $t('Kiosk.AddKioskPrompt.Queues'),
              })
            "
            :placeholder="$t('Kiosk.AddKioskPrompt.Queues')"
            class="w-100 mb-2"
            :label="$t('Kiosk.AddKioskPrompt.Queues')"
            autocomplete
            multiple
            v-model="editPromptData.queues"
          >
            <vs-select-item
              :key="index"
              :value="queue.id"
              :text="queue.title"
              v-for="(queue, index) in queues"
            />
          </vs-select>

          <vs-select
            class="w-100 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.Status')"
            v-model="editPromptData.status"
          >
            <vs-select-item
              :value="0"
              :text="$t('Kiosk.AddKioskPrompt.StatusInactive')"
            />
            <vs-select-item
              :value="1"
              :text="$t('Kiosk.AddKioskPrompt.StatusActive')"
            />
          </vs-select>

          <h4 class="mb-4 mt-4">Functionalities</h4>
          <vs-row>
            <vs-col vs-w="6">
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.printTicket"
              >
                {{ $t("Kiosk.AddKioskPrompt.PrintTicket") }}
              </vs-checkbox>

              <div
                class="ticket-sty"
                v-if="editPromptData.printTicket"
                style="
                        border: 1px solid #888;
                        padding: 10px;
                        border-radius: 5px;
                      "
              >
                <input
                  type="radio"
                  id="one"
                  :value="'Long'"
                  v-model="editPromptData.ticket_style"
                />
                <label for="one" style="margin-left: 10px">
                  {{ $t("Kiosk.AddKioskPrompt.LongTicket") }}
                </label>
                <br />
                <input
                  type="radio"
                  id="two"
                  :value="'Short'"
                  v-model="editPromptData.ticket_style"
                />
                <label for="two" style="margin-left: 10px">
                  {{ $t("Kiosk.AddKioskPrompt.ShortTicket") }}
                </label>
              </div>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.smsTicket"
              >
                {{ $t("Kiosk.AddKioskPrompt.SMSTicket") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.allowBooking"
              >
                {{ $t("Kiosk.AddKioskPrompt.AllowBooking") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.allowQueue"
              >
                {{ $t("New.allowQueue") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.allowMultipleServices"
              >
                {{ $t("Kiosk.AddKioskPrompt.allowMultipleServices") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.allowQuantityServices"
              >
                {{ $t("Kiosk.AddKioskPrompt.allowQuantityServices") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.collectDetails"
              >
                {{ $t("Kiosk.AddKioskPrompt.CollectCustomerDetails") }}
              </vs-checkbox>
            </vs-col>
            <vs-col vs-w="6">
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.require_internal_id"
              >
                {{ $t("Kiosk.AddKioskPrompt.RequireInternalId") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.should_print"
              >
                {{ $t("Kiosk.AddKioskPrompt.ShouldPrint") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.show_keyboard"
              >
                {{ $t("Kiosk.AddKioskPrompt.ShowKeyboard") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.loginRequired"
              >
                {{ $t("Kiosk.AddKioskPrompt.GuestLogin") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.multi_language"
              >
                Multi languages
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.allowTxtQte"
              >
                {{ "Modify quantity services text" }}
              </vs-checkbox>

              <div v-if="editPromptData.allowTxtQte">
                <vs-textarea
                  counter="500"
                  rows="5"
                  :label="'Services quantity text'"
                  v-model="editPromptData.quantityText"
                  class="w-100 mb-2"
                />
              </div>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.allowPrintWebsocket"
              >
                {{ $t("Kiosk.AddKioskPrompt.PrintWebsocket") }}
              </vs-checkbox>
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="editPromptData.displayPhonenumberMessage"
              >
                {{ $t("Kiosk.AddKioskPrompt.displayPhonenumberMessage") }}
              </vs-checkbox>
            </vs-col>
          </vs-row>

          <div
            class="ticket-sty"
            style="
                        border: 1px solid #888;
                        padding: 10px;
                        border-radius: 5px;
                      "
          >
            <b>Language par defaut: </b><br />
            <input
              type="radio"
              id="onee"
              :value="'fr'"
              v-model="editPromptData.default_language"
            />
            <label for="onee" style="margin-left: 10px">
              Francais
            </label>
            <br />
            <input
              type="radio"
              id="twoo"
              :value="'en'"
              v-model="editPromptData.default_language"
            />
            <label for="twoo" style="margin-left: 10px">
              Anglais
            </label>
            <br />
            <input
              type="radio"
              id="threee"
              :value="'ar'"
              v-model="editPromptData.default_language"
            />
            <label for="threee" style="margin-left: 10px">
              Arabe
            </label>
          </div>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.GuestPseudo')"
            v-model="editPromptData.pseudo"
            v-if="editPromptData.loginRequired == 0"
          >
            <vs-select-item :value="1" :text="$t('Kiosk.Pseudos.Customer')" />
            <vs-select-item :value="2" :text="$t('Kiosk.Pseudos.Patient')" />
            <vs-select-item :value="3" :text="$t('Kiosk.Pseudos.User')" />
          </vs-select>

          <vs-row>
            <vs-col vs-w="6">
              <vs-input
                :label="$t('Kiosk.AddKioskPrompt.IpAddress')"
                v-model="editPromptData.ip_address"
                class="w-100 mb-2"
              />
            </vs-col>
            <vs-col vs-w="6">
              <vs-input
                :label="$t('Kiosk.AddKioskPrompt.MacAddress')"
                v-model="editPromptData.mac_address"
                class="w-100 mb-2"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>

      <vs-tab :label="'Appearance'">
        <div>
          <vs-row class="mb-2 mt-2">
            <vs-col vs-w="6">
              <vs-select
                style="width: 100%"
                class="mb-2 mt-2"
                :label="$t('Kiosk.AddKioskPrompt.Theme')"
                v-model="editPromptData.theme"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in themes"
                />
              </vs-select>
            </vs-col>

            <vs-col vs-w="5">
              <label class="vs-select--label mt-2">{{
                $t("Kiosk.AddKioskPrompt.Zoom")
              }}</label>
              <br />
              <vs-input-number
                style="margin: 0px 15px"
                size="large"
                :max="100"
                :min="20"
                v-model="editPromptData.zoom"
              />
            </vs-col>
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mb-2 mt-2"
              for="color-add-edit"
              style="width: 50%"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryDark") }}</label
            >
            <vs-checkbox
              class="mb-2 mt-2"
              style="width: 10%"
              v-model="defaultEditPrimary"
            ></vs-checkbox>
            <input
              v-if="!defaultEditPrimary"
              v-model="editPromptData.primary"
              type="color"
              style="width: 15%"
              class="mb-2 mt-2"
            />
          </vs-row>
          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2 mb-2"
              style="width: 50%"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryMedium") }}</label
            >
            <vs-checkbox
              class="mb-2 mt-2"
              style="width: 10%"
              v-model="defaultEditSecondary"
            ></vs-checkbox>
            <input
              v-if="!defaultEditSecondary"
              v-model="editPromptData.secondary"
              type="color"
              style="width: 15%"
              class="mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2 mb-2"
              for="color-add-edit"
              style="width: 50%"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryLight") }}</label
            >
            <vs-checkbox
              class="mb-2 mt-2"
              style="width: 10%"
              v-model="defaultEditSuccess"
            ></vs-checkbox>
            <input
              v-if="!defaultEditSuccess"
              v-model="editPromptData.success"
              type="color"
              style="width: 15%"
              class="mb-2 mt-2"
            />
          </vs-row>
          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2"
              for="color-add-edit"
              style="width: 50%"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.Secondary") }}</label
            >
            <vs-checkbox
              class="mb-2 mt-2"
              style="width: 10%"
              v-model="defaultEditDanger"
            ></vs-checkbox>
            <input
              v-if="!defaultEditDanger"
              v-model="editPromptData.danger"
              type="color"
              style="width: 15%"
              class="mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mb-2 mt-2"
              for="color-add-edit"
              style="width: 50%"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.Info") }}</label
            >
            <vs-checkbox
              class="mb-2 mt-2"
              style="width: 10%"
              v-model="defaultEditInfo"
            ></vs-checkbox>
            <input
              v-if="!defaultEditInfo"
              v-model="editPromptData.info"
              type="color"
              style="width: 15%"
              class="mb-2 mt-2"
            />
          </vs-row>

          <vs-input
            type="file"
            class="w-100 mt-2"
            id="editFileInput"
            :label="$t('Kiosk.AddKioskPrompt.Photo')"
            v-model="editPromptData.photo"
          />
          <vs-checkbox
            color="danger"
            class="justify-content-start w-100 mb-2 mt-2"
            v-if="editPromptData.photoUrl.length"
            v-model="editPromptData.photoDelete"
            >{{ $t("Kiosk.EditKioskPrompt.PhotoUploadedDelete") }}</vs-checkbox
          >
          <p v-if="editPromptData.photoUrl.length" class="mt-2">
            <a :href="editPromptData.photoUrl" target="_blank">{{
              $t("Kiosk.EditKioskPrompt.PhotoUploaded")
            }}</a>
          </p>

          <vs-input
            :label="$t('Kiosk.AddKioskPrompt.imagePath')"
            v-model="promptData.imagePath"
            class="w-100 mb-2"
          />
        </div>
      </vs-tab>
      <vs-tab :label="'Kiosk V2'">
        <div>
          <vs-row class="m-2 pt-3">
            <vs-col vs-w="6">
              <h6>Config Kiosk v2</h6>
            </vs-col>
            <vs-col vs-w="6">
              <vs-row>
                <label for="">Activate V2 styling</label>
                <vs-switch color="primary" v-model="displayConfigV2" />
              </vs-row>
            </vs-col>
          </vs-row>

          <div v-if="displayConfigV2">
            <vs-row class="ml-1">
              <vs-col vs-w="6">
                <vs-select
                style="width: 100%"
                class="mb-2 mt-2"
                :label="$t('Kiosk.AddKioskPrompt.Theme')"
                v-model="editPromptData.config_v2.theme"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in themesV2"
                />
              </vs-select>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.primaryColor") }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.primaryColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.secondaryColor") }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.secondaryColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br>
                  <br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.textColor") }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.textColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-1 ml-3"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.IdleTimeout") }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.IdleTimeout"
                    type="number"
                    style="width: 28%"
                    class="mb-2 mt-2 ml-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{$t("KioskConfig_v2.services.Title")}}</h4>
               
                <vs-row>
                <label for="">{{ backgroundServiceImage ? "Image" : "Color" }}</label>
                <vs-switch color="primary" v-model="backgroundServiceImage" />
              </vs-row>
              <div v-if="backgroundServiceImage">
                <vs-input
                  type="file"
                  class="w-100 mt-2"
                  id="servicesBackground"
                  :label="$t('KioskConfig_v2.services.background')"
                  @change="updateConfigBackground"
                />
                <span class="text-primary mt-3" v-if="editPromptData.config_v2.services.background" @click="checkExistingImage('backgroundService')">display image</span>
                </div>
                <vs-row class="ml-2" v-else>
                  <label
                    class="vs-input--label mb-2 mt-2"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.background') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.services.background"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2 text-primary"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.titleColor') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.services.titleColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row>
                <label for="">{{ servicesServiceBackgroundImage ? "Image" : "Color" }}</label>
                <vs-switch color="primary" v-model="servicesServiceBackgroundImage" />
                </vs-row>
              <div v-if="servicesServiceBackgroundImage">
                <vs-input
                  type="file"
                  class="w-100 mt-2"
                  id="servicesServiceBackground"
                  :label="$t('KioskConfig_v2.services.serviceBackground')"
                  @change="updateServiceBackground"
                />
                <span class="text-primary mt-3" v-if="editPromptData.config_v2.services.serviceBackground" @click="checkExistingImage('servicesServiceBackground')">display image</span>
                </div>
                <vs-row class="ml-2" v-else>
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{$t('KioskConfig_v2.services.serviceBackground')}}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.services.serviceBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{$t('KioskConfig_v2.services.serviceTextColor')}}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.services.serviceTextColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-col class="mb-3">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 70%; margin-left: 8px;"
                    >{{$t('KioskConfig_v2.services.selectedServiceBackgroundColor')}}</label
                  >

                  <input
                    v-model="
                      editPromptData.config_v2.services
                        .selectedServiceBackgroundColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.selectedServiceTextColor') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.services.selectedServiceTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-4"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.mainButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.services.mainButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-2"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.mainButtonTextColor') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.services.mainButtonTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.booking.Title') }}</h4>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.background') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.booking.background"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.titleColor') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.booking.titleColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.subColor') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.booking.subColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.textColor') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.booking.textColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.booking.calendarBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarSlotBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.booking.calendarSlotBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-4"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.timeSlotBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.booking.timeSlotBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarDayBackgroundColor') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.booking
                        .calendarDayBackgroundColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>
                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.booking.calendarButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>
                </vs-col>


                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.header.Title') }}</h4>

               
                  <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-2"
                    v-model="editPromptData.config_v2.header.showHeader"
                  >
                  {{ $t('KioskConfig_v2.header.showHeader') }}
                  </vs-checkbox>
                  <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.header.headerBackground') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.header.headerBackground"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                  <vs-input
                    type="file"
                    class="w-100 mt-2"
                    id="updateheaderLogo"
                    :label="$t('KioskConfig_v2.header.logo')"
                    v-model="headerLogo"
                    @change="updateheaderLogo"
                  />
                  <span class="text-primary mt-3" v-if="editPromptData.config_v2.header.logo" @click="checkExistingImage('logoHeader')">display image</span>
                  <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-2"
                    v-model="editPromptData.config_v2.header.showHeader"
                  >
                  {{ $t('KioskConfig_v2.header.showHeader') }}
                  </vs-checkbox>
       
                <!--  -->
              </vs-col>
              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.ticket.Title') }}</h4>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.textColor') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.printTicket.textColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.secondaryTextColor') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.printTicket.secondaryTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-input
                  type="file"
                  class="w-100 mt-2"
                  id="updatePrintTicketBackgroundImage"
                  :label="$t('KioskConfig_v2.ticket.backgroundImage')"
                  v-model="printTicketBackgroundImage"
                  @change="updatePrintTicketBackgroundImage"
                />
                <div v-if="!PrintTicketBackgroundImageDeleted && editPromptData.config_v2.printTicket.backgroundImage">
                <span class="text-primary mt-3" @click="checkExistingImage('backgroundImagePrint')">display image</span>
                <span class="text-danger ml-3 mt-3" @click="deletePrintTicketBackgroundImage">X</span>
                </div>
                
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.background') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.printTicket.background"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.anonButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.printTicket.anonButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.sendButtonTextColor') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.printTicket.sendButtonTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.backgroundTicketHeader') }}</label
                  >
                  <input
                    v-if="editPromptData.config_v2.printTicket.backgroundTicketHeader"
                    v-model="
                      editPromptData.config_v2.printTicket.backgroundTicketHeader
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                  <input
                  v-else
                    v-model="backgroundTicketHeader"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.ticketHeaderTitle') }}</label
                  >
                  <input
                    v-if="editPromptData.config_v2.printTicket.ticketHeaderTitle"
                    v-model="
                      editPromptData.config_v2.printTicket.ticketHeaderTitle
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                  <input
                  v-else
                    v-model="ticketHeaderTitle"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.printTicketTimeout') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.printTicket.printTicketTimeout
                    "
                    type="number"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.numpad.Title') }}</h4>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.numBackground') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.numPad.numBackground"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.numPrimary') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.numPad.numPrimary"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.numSecondary') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.numPad.numSecondary"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.anonymSendButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.numPad.anonymSendButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.anonymSendButtonColor') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.numPad.anonymSendButtonColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>

                
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.sendButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      editPromptData.config_v2.numPad.sendButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-2"
                  />
           

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.sendButtonColor') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.numPad.sendButtonColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>

                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.footer.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-2"
                  v-model="editPromptData.config_v2.footer.showFooter"
                >
                {{ $t('KioskConfig_v2.footer.showFooter') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.footer.footerBackground') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.footer.footerBackground"
                    type="text"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>

                <div v-if="editPromptData.config_v2.onServiceSelect">
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.onServiceSelect.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-3"
                  v-model="editPromptData.config_v2.onServiceSelect.status"
                >
                {{ $t('KioskConfig_v2.onServiceSelect.Status') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.onServiceSelect.Timeout') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.onServiceSelect.timeout"
                    type="number"
                    min="2000"
                    step="1000"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                </div>
                <div v-else>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.onServiceSelect.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-3"
                  v-model="onServiceSelect.status"
                >
                {{ $t('KioskConfig_v2.onServiceSelect.Status') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.onServiceSelect.Timeout') }}</label
                  >
                  <input
                    v-model="onServiceSelect.timeout"
                    type="number"
                    min="2000"
                    step="1000"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                </div>

                <div v-if="editPromptData.config_v2.onPrintTicket">
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.onPrintTicket.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-4"
                  v-model="editPromptData.config_v2.onPrintTicket.status"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.onPrintTicket.Timeout') }}</label
                  >
                  <input
                    v-model="editPromptData.config_v2.onPrintTicket.timeout"
                    type="number"
                    min="2000"
                    step="1000"
                    class="mb-2 mt-2*"
                  />
                </vs-row>
              </vs-col>
            </div>
                <div v-else>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.onPrintTicket.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-4"
                  v-model="onPrintTicket.status"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.onPrintTicket.Timeout') }}</label
                  >
                  <input
                    v-model="onPrintTicket.timeout"
                    type="number"
                    min="2000"
                    step="1000"
                    class="mb-2 mt-2*"
                  />
                </vs-row>
              </vs-col>
            </div>
            </vs-row>
            <!-- start -->
            <div v-if="editPromptData.config_v2.anonymousHibernateInterval">
              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.anonymousHibernateInterval.Title') }}</h4>

                <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-2"
                    v-model="editPromptData.config_v2.anonymousHibernateInterval.status"
                >
                  {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
              </vs-col>
              <vs-col vs-w="6">
                <br><br><br>
                <vs-row class="ml-2 mt-4">
                  <label
                      class="vs-input--label mb-2 mt-2"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.anonymousHibernateInterval.Timeout') }}</label
                  >
                  <input
                      v-model="editPromptData.config_v2.anonymousHibernateInterval.timeout"
                      type="number"
                      min="2000"
                      step="1000"
                      class="mb-2 mt-2"
                  />
                </vs-row>
              </vs-col>
            </div>

            <div v-else>
              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.anonymousHibernateInterval.Title') }}</h4>

                <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-4"
                    v-model="anonymousHibernateInterval.status"
                >
                  {{ $t('KioskConfig_v2.anonymousHibernateInterval.Status') }}
                </vs-checkbox>
              </vs-col>
              <vs-col vs-w="6">
                <br><br><br>
                <vs-row class="ml-2">
                  <label
                      class="vs-input--label mb-2"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.anonymousHibernateInterval.Timeout') }}</label
                  >
                  <input
                      v-model="anonymousHibernateInterval.timeout"
                      type="number"
                      min="2000"
                      step="1000"
                      class="mb-2 mt-2*"
                  />
                </vs-row>
              </vs-col>
            </div>
            <!-- end -->
            <div v-if="editPromptData.config_v2.allowPagination">
                <vs-col vs-w="12">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.allowPagination') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-4"
                  v-model="editPromptData.config_v2.allowPagination"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                </vs-col>
             
            </div>
                <div v-else>
                  <vs-col vs-w="12">
                  
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.allowPagination') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-4"
                  v-model="allowPagination"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                </vs-col>
            </div>
            <div>
              <!--  -->
              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.printVariables.Title') }}</h4>
    
                  <vs-select
                    v-if="editPromptData.config_v2.printTheme"
                    style="width: 100%"
                    class="mb-2 mt-2"
                    :label="$t('KioskConfig_v2.printVariables.PrintTheme')"
                    v-model="editPromptData.config_v2.printTheme"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in printThemeArray"
                    />
                  </vs-select>
                  <vs-select
                  v-else
                  style="width: 100%"
                  class="mb-2 mt-2"
                  :label="$t('KioskConfig_v2.printVariables.PrintTheme')"
                  v-model="printTheme"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in printThemeArray"
                    />
                  </vs-select>
                
                </vs-col>
              <vs-row>
                
                <vs-col vs-w="6">
                <label
                      class="vs-input--label mt-2"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.printVariables.ThankYouText') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.thankYouText"
                      v-model="editPromptData.config_v2.thankYouText"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="thankYouText"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
                <vs-col vs-w="6">
                
                <label
                      class="vs-input--label mb-2 mt-2"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.printVariables.FooterUrl') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.footerUrl"
                      v-model="editPromptData.config_v2.footerUrl"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="footerUrl"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
              </vs-row>
              <!--  -->
              <vs-row>
                <vs-col vs-w="6">
                <label
                      class="vs-input--label mb-2 "
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.printVariables.HeaderSpace') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.headerSpace"
                      v-model="editPromptData.config_v2.headerSpace"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="headerSpace"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
                <vs-col vs-w="6">
               
                <label
                      class="vs-input--label mb-2 mt-2"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.printVariables.LogoHeight') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.logoHeight"
                      v-model="editPromptData.config_v2.logoHeight"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="logoHeight"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
              </vs-row>
              <!--  -->
              <vs-row>
              <vs-col vs-w="6">
               
               <label
                     class="vs-input--label mb-2 mt-2"
                     for="color-add-edit"
                     style="width: 50%"
                 >{{ $t('KioskConfig_v2.printVariables.LogoWidth') }}</label
                 >
                 <br/>
               <input
                     v-if="editPromptData.config_v2.logoWidth"
                     v-model="editPromptData.config_v2.logoWidth"
                     type="text"
                     class="mb-2 mt-2 ml-1"
                 />
               <input
                     v-else
                     v-model="logoWidth"
                     type="text"
                     class="mb-2 mt-2 ml-1"
                 />
               </vs-col>
             </vs-row>
            </div>

            <div>
              <!--  -->
              <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.Category.Title') }}</h4>
              <vs-row>
                
              <vs-col vs-w="6">
                
                <vs-checkbox
                v-if="editPromptData.config_v2.allowCategory"
                  class="justify-content-start w-100 mb-2 mt-4"
                  v-model="editPromptData.config_v2.allowCategory"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                <vs-checkbox
                v-else
                  class="justify-content-start w-100 mb-2 mt-4"
                  v-model="allowCategory"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                
                </vs-col>

                <vs-col vs-w="6">
                <label
                      class="vs-input--label"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.Category.TitleTextFR') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.categoryTitleTextFr"
                      v-model="editPromptData.config_v2.categoryTitleTextFr"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="categoryTitleTextFr"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
              </vs-row>
              <!--  -->
              <vs-row>
                <vs-col vs-w="6">
                <label
                      class="vs-input--label"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.Category.TitleTextAR') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.categoryTitleTextAr"
                      v-model="editPromptData.config_v2.categoryTitleTextAr"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="categoryTitleTextAr"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
                <vs-col vs-w="6">
                <label
                      class="vs-input--label"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.Category.TitleTextEN') }}</label
                  >
                  <br/>
                <input
                      v-if="editPromptData.config_v2.categoryTitleTextEn"
                      v-model="editPromptData.config_v2.categoryTitleTextEn"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                <input
                      v-else
                      v-model="categoryTitleTextEn"
                      type="text"
                      class="mb-2 mt-2 ml-1"
                  />
                </vs-col>
              </vs-row>
              
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <vs-row class="ml-1 mt-3">
      <vs-col vs-w="4">
        <vs-button color="warning" @click="updateKiosk()" class="w-100 mb-2">{{
          $t("Kiosk.EditKioskPrompt.SubmitButton")
        }}</vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { kioskService, queueService } from "../../_services";
import router from "../../_helpers/router";
// moment

export default {
  name: "CreateKiosk",
  data: () => ({
    title: "CreateKiosk",
    themeVersions: [
    { value: "firstTheme", title: "firstTheme" },
      { value: "secondTheme", title: "secondTheme" },
      { value: "thirdTheme", title: "thirdTheme" },
      { value: "sixthTheme", title: "sixthTheme" },
      { value: "sixthTheme", title: "sixthTheme" },
      { value: "sixthTheme", title: "sixthTheme" },
      
    ],
    printThemeArray: [
      { value: "shortStyle", text: "shortStyle" },
      { value: "longStyle", text: "longStyle" },
      { value: "genericStyle", text: "genericStyle" }
    ],
    promptData: {
      multi_language: true,
      default_language: "fr",
      name: "",
      photo: "",
      theme: "liberrex",
      status: 1,
      printTicket: 1,
      smsTicket: "Long",
      ticket_style: "1",
      allowBooking: 0,
      allowQueue: 1,
      allowMultipleServices: 1,
      allowQuantityServices: 0,
      allowTxtQte: 0,
      quantityText: `{"en": "", "fr": "", "ar": ""}`,
      allowPrintWebsocket: 0,
      imagePath: "",
      collectDetails: 0,
      queues: [],
      ip_address: "",
      mac_address: "",
      require_internal_id: 0,
      should_print: 0,
      show_keyboard: 0,
      loginRequired: 0,
      pseudo: 0,
      primary: "",
      secondary: "",
      success: "",
      danger: "",
      zoom: 100,
      info: "",
    },
    defaultInfo: true,
    errors: {
      name: false,
      queues: false,
    },
    defaultPrimary: true,
    defaultSecondary: true,
    defaultSuccess: true,
    defaultDanger: true,
    defaultInfo: true,
    defaultEditPrimary: false,
    defaultEditSecondary: false,
    defaultEditSuccess: false,
    defaultEditDanger: false,
    defaultEditInfo: false,
    servicesBackground: null,
    headerLogo: null,
    printTicketBackgroundImage: null,
    backgroundServiceImage: true,
    servicesServiceBackgroundImage: true,
    PrintTicketBackgroundImageDeleted: false,
    onServiceSelect: {
        status: false,
        timeout: null
      },
    onPrintTicket: {
      status: false,
      timeout: null
    },
    anonymousHibernateInterval: {
      status: true,
      timeout: 30000
    },
    allowPagination: false,
    allowCategory: false,
    thankYouText: '',
    footerUrl: '',
    headerSpace: '',
    logoHeight: '',
    logoWidth: '',
    backgroundTicketHeader: '',
    ticketHeaderTitle: '',
    printTheme: "shortStyle",
    categoryTitleTextFr: '',
    categoryTitleTextAr: '',
    categoryTitleTextEn: ''
  }),
  props: {
    queues: Array,
    themes: Array,
    themesV2: Array,
    displayConfigV2: Boolean,
    editPromptData: Object,
  },
  methods: {
    deletePrintTicketBackgroundImage() {
      this.editPromptData.config_v2.printTicket.backgroundImage = null;
      this.PrintTicketBackgroundImageDeleted = true;
    },
    updateServiceBackground() {
      if (
        document.getElementById("servicesServiceBackground") &&
        document.getElementById("servicesServiceBackground").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("servicesServiceBackground").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.editPromptData.config_v2.services.serviceBackground = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    checkExistingImage(varName) {
        var image = new Image();
        if (varName == "backgroundService") {
          image.src = this.editPromptData.config_v2.services.background;
        }
        if (varName == "logoHeader") {
          image.src = this.editPromptData.config_v2.header.logo;
        }
        if (varName == "backgroundImagePrint") {
          image.src = this.editPromptData.config_v2.printTicket.backgroundImage;
        }
        if (varName == "servicesServiceBackground") {
          image.src = this.editPromptData.config_v2.services.serviceBackground;
        }
        

        var w = window.open("");
        w.document.write(image.outerHTML);
    },
    updateConfigBackground() {
      if (
        document.getElementById("servicesBackground") &&
        document.getElementById("servicesBackground").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("servicesBackground").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.editPromptData.config_v2.services.background = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    updateheaderLogo() {
      if (
        document.getElementById("updateheaderLogo") &&
        document.getElementById("updateheaderLogo").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("updateheaderLogo").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.editPromptData.config_v2.header.logo = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    updatePrintTicketBackgroundImage() {
      if (
        document.getElementById("updatePrintTicketBackgroundImage") &&
        document.getElementById("updatePrintTicketBackgroundImage").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("updatePrintTicketBackgroundImage")
          .files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.editPromptData.config_v2.printTicket.backgroundImage = rawImg;
          this.PrintTicketBackgroundImageDeleted = false;
        };
        reader.readAsDataURL(file);
      }
    },
    getAllKiosk() {
      this.$emit("refresh_kiosk", "refresh_kiosk");
    },
    validateEditPromptFields() {
      this.errors.name = this.editPromptData.name ? false : true;
      this.errors.queues = this.editPromptData.queues.length > 0 ? false : true;

      let { name, queues } = this.errors;
      return !(name || queues);
    },
    updateKiosk() {
      let res = this.validateEditPromptFields();
      if (!res) {
        return false;
      }
      this.showLoading();
      let kioskData = new FormData();
      kioskData.append("name", this.editPromptData.name);
      kioskData.append("queues", this.editPromptData.queues.join(","));
      kioskData.append("theme", this.editPromptData.theme);
      kioskData.append("status", this.editPromptData.status);
      kioskData.append("ip_address", this.promptData.ip_address);
      kioskData.append("mac_address", this.promptData.mac_address);
      kioskData.append("deletePhoto", this.editPromptData.photoDelete);
      kioskData.append(
        "allow_booking",
        this.editPromptData.allowBooking ? 1 : 0
      );
      kioskData.append("allow_queue", this.editPromptData.allowQueue ? 1 : 0);
      kioskData.append(
        "allow_multiple_services",
        this.editPromptData.allowMultipleServices ? 1 : 0
      );
      kioskData.append(
        "allow_quantity_services",
        this.editPromptData.allowQuantityServices ? 1 : 0
      );
      kioskData.append(
        "allow_quantity_text",
        this.editPromptData.allowTxtQte ? 1 : 0
      );
      // kioskData.append("quantity_text", "");
      kioskData.append("quantity_text", this.editPromptData.quantityText);
      kioskData.append(
        "allow_print_websocket",
        this.editPromptData.allowPrintWebsocket ? 1 : 0
      );
      kioskData.append(
        "display_phonenumber_message",
        this.editPromptData.displayPhonenumberMessage ? 1 : 0
      );
      kioskData.append("image_path", this.editPromptData.imagePath);
      kioskData.append("print_ticket", this.editPromptData.printTicket ? 1 : 0);
      kioskData.append("sms_ticket", this.editPromptData.smsTicket ? 1 : 0);
      kioskData.append("ticket_style", this.editPromptData.ticket_style);
      kioskData.append(
        "collect_details",
        this.editPromptData.collectDetails ? 1 : 0
      );
      kioskData.append(
        "require_internal_id",
        this.editPromptData.require_internal_id ? 1 : 0
      );
      kioskData.append(
        "should_print",
        this.editPromptData.should_print ? 1 : 0
      );
      kioskData.append(
        "show_keyboard",
        this.editPromptData.show_keyboard ? 1 : 0
      );
      kioskData.append(
        "login_required",
        this.editPromptData.loginRequired ? 1 : 0
      );
      kioskData.append("pseudo", this.editPromptData.pseudo);
      kioskData.append("primary", this.editPromptData.primary);
      kioskData.append("info", this.editPromptData.info);
      kioskData.append("secondary", this.editPromptData.secondary);
      kioskData.append("success", this.editPromptData.success);
      kioskData.append("danger", this.editPromptData.danger);
      kioskData.append("zoom", this.editPromptData.zoom);
      kioskData.append("multi_language", this.editPromptData.multi_language);
      kioskData.append(
        "default_language",
        this.editPromptData.default_language
      );

      if (!this.defaultEditPrimary) {
        kioskData.append("primary", this.editPromptData.primary);
      } else if (this.defaultEditPrimary) {
        kioskData.append("primary", "");
      }
      if (!this.defaultEditSecondary) {
        kioskData.append("secondary", this.editPromptData.secondary);
      } else if (this.defaultEditSecondary) {
        kioskData.append("secondary", "");
      }
      if (!this.defaultEditSuccess) {
        kioskData.append("success", this.editPromptData.success);
      } else if (this.defaultEditSuccess) {
        kioskData.append("success", "");
      }
      if (!this.defaultEditDanger) {
        kioskData.append("danger", this.editPromptData.danger);
      } else if (this.defaultEditDanger) {
        kioskData.append("danger", "");
      }
      if (!this.defaultEditInfo) {
        kioskData.append("info", this.editPromptData.info);
      } else if (this.defaultEditInfo) {
        kioskData.append("info", "");
      }
      // V2 config
      if (!this.displayConfigV2) {
        kioskData.append("config_v2", null);
      } else {
        if(!this.editPromptData.config_v2.onServiceSelect || !this.editPromptData.config_v2.onPrintTicket) {
          this.editPromptData.config_v2.onServiceSelect = this.onServiceSelect;
          this.editPromptData.config_v2.onPrintTicket = this.onPrintTicket;
        }
        if(!this.editPromptData.config_v2.allowPagination) {
          this.editPromptData.config_v2.allowPagination = this.allowPagination;
        }
        if(!this.editPromptData.config_v2.thankYouText) {
          this.editPromptData.config_v2.thankYouText = this.thankYouText;
        }
        if(!this.editPromptData.config_v2.footerUrl) {
          this.editPromptData.config_v2.footerUrl = this.footerUrl;
        }
        if(!this.editPromptData.config_v2.headerSpace) {
          this.editPromptData.config_v2.headerSpace = this.headerSpace;
        }
        if(!this.editPromptData.config_v2.logoHeight) {
          this.editPromptData.config_v2.logoHeight = this.logoHeight;
        }
        if(!this.editPromptData.config_v2.logoWidth) {
          this.editPromptData.config_v2.logoWidth = this.logoWidth;
        }
        if(!this.editPromptData.config_v2.printTheme) {
          this.editPromptData.config_v2.printTheme = this.printTheme;
        }
        if(!this.editPromptData.config_v2.anonymousHibernateInterval) {
          this.editPromptData.config_v2.anonymousHibernateInterval = this.anonymousHibernateInterval;
        }
        if(!this.editPromptData.config_v2.printTicket.backgroundTicketHeader) {
          this.editPromptData.config_v2.printTicket.backgroundTicketHeader = this.backgroundTicketHeader;
        }
        if(!this.editPromptData.config_v2.printTicket.ticketHeaderTitle) {
          this.editPromptData.config_v2.printTicket.ticketHeaderTitle = this.ticketHeaderTitle;
        }
        if(!this.editPromptData.config_v2.allowCategory) {
          this.editPromptData.config_v2.allowCategory = this.allowCategory;
        }
        if(!this.editPromptData.config_v2.categoryTitleTextFr) {
          this.editPromptData.config_v2.categoryTitleTextFr = this.categoryTitleTextFr;
        }
        if(!this.editPromptData.config_v2.categoryTitleTextAr) {
          this.editPromptData.config_v2.categoryTitleTextAr = this.categoryTitleTextAr;
        }
        if(!this.editPromptData.config_v2.categoryTitleTextEn) {
          this.editPromptData.config_v2.categoryTitleTextEn = this.categoryTitleTextEn;
        }
        kioskData.append("config_v2", JSON.stringify(this.editPromptData.config_v2));
      }

      if (
        document.getElementById("editFileInput") &&
        document.getElementById("editFileInput").files[0]
      ) {
        kioskData.append(
          "photo",
          document.getElementById("editFileInput").files[0]
        );
      }
      kioskService
        .update(this.editPromptData.id, kioskData)
        .then(
          function(data) {
            this.getAllKiosk();
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Kiosk.EditKioskPrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Kiosk.EditKioskPrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.close();
            this.hideLoading();
          }.bind(this)
        );
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    close() {
      this.$emit("hide", "close");
    },
    showLoading() {
      this.$vs.loading({
        container: "#kiosks-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#kiosks-box > .con-vs-loading");
    },
  },
  mounted() {
    if (!this.editPromptData.primary) {
      this.defaultEditPrimary = true;
    }
    if (!this.editPromptData.secondary) {
      this.defaultEditSecondary = true;
    }
    if (!this.editPromptData.success) {
      this.defaultEditSuccess = true;
    }
    if (!this.editPromptData.danger) {
      this.defaultEditDanger = true;
    }
    if (!this.editPromptData.info) {
      this.defaultEditInfo = true;
    }
  },
};
</script>
